import { useState } from 'react'

const SearchBar = ({ initialValue = '', search, children }) => {
  const [searchValue, setSearchValue] = useState(initialValue)
  const onSearch = (value) => (value || value === '') && search(value)
  const onKeyDown = ({ key }) => key === 'Enter' && onSearch(searchValue)
  return children({
    searchValue,
    setSearchValue,
    onKeyDown,
    onSearch,
  })
}
export default SearchBar
